const AbstractView = require("./AbstractView");
const postal = require("./PubSub");
const config = require("../settings/Configuration");

/**
 * @abstract
 * @class
 * @implements {AbstractView}
 */
const AbstractResourcesView = function(launcher) {
    const renderers = {};
    const self = this;

    const $searchInput = $('<input data-type="search" data-i18n="[placeholder]common::search.placeholder">');
    const $searchField = $('<form class="ui-filterable">');
    $searchField.append($searchInput);

    const $listView = $('<ul class="resourcesList" data-role="listview" data-inset="false">');
    const $content = $('<div class="pullToRefresh scrollContent">')
        .append($("<div>")
            .append($searchField, $listView));

    this.renderResourceIcons = function(resourceItems, $view, resourceLayoutType, onClick) {
        $view.empty();
        const layoutClass = resourceLayoutType === "list" ? "resourcesListList" : "resourcesList";
        $view.removeClass("resourcesList").removeClass("resourcesListList").addClass(layoutClass);

        Object.keys(resourceItems).forEach(function(itemId) {
            const resource = resourceItems[itemId];
            const renderer = renderers[resource.type];

            if (renderer === undefined) {
                console.debug("No renderer available for resource");
            } else {
                const viewClass = resourceLayoutType === "list" ? "resourceItemList" : "resourceItem";

                // Build HTML that contains the desired information
                const rowAttributes = {
                    class : viewClass,
                    "data-resource-id" : resource.id,
                    "data-icon" : false,
                    "data-theme" : "a"
                };
                if (resourceLayoutType === "list") {
                    rowAttributes["title"] = resource.name;
                }
                const $row = $("<li/>", rowAttributes);

                if (resourceLayoutType === "list") {
                    const icon = renderer.renderResourceListViewIcon(resource);
                    $row.on("click", onClick).append(icon);
                } else {
                    const icon = renderer.render(resource, undefined, renderers);
                    $row.append($("<a/>", {href : "#"})
                        .on("click", onClick)
                        .append(icon));
                }
                $row.append($("<div/>")
                    .append($("<p/>", {text : resource.name})));
                $view.append($row);
            }
        });

        layoutIcons($view);
    };

    const layoutIcons = function($view) {
        // Re-layout the icons on the page
        $view.find(".dummyResourceItem").remove();
        const iconWidth = 80;
        const fudge = 20;
        const totalWidth = $content.width() - fudge; // Reduced to accommodate scroll bars
        const $items = $view.find("> li");

        // Figure out how much space we should allow for each item including padding (increases as screen size gets larger)
        const itemWidth = iconWidth + fudge + (iconWidth * (1 - (Math.min((iconWidth * 5), totalWidth) / totalWidth)));

        const maxIcons = Math.floor(totalWidth / itemWidth);
        const margin = Math.floor(((totalWidth - (maxIcons * iconWidth)) / 2) / maxIcons);

        // Add in dummy items to fill grid correctly
        const dummiesRequired = (($items.length % maxIcons) === 0)
            ? 0
            : maxIcons - ($items.length % maxIcons);

        for (let i = 0; i < dummiesRequired; i++) {
            let $dummy = $("<li/>")
                .addClass("dummyResourceItem")
                .addClass("resourceItem")
                .css("margin-left", margin + "px")
                .css("margin-right", margin + "px");

            $view.append($dummy);
        }

        $items.css("margin-left", margin + "px")
            .css("margin-right", margin + "px");

        if ($view.hasClass("ui-listview")) {
            $view.listview("refresh");
        }
    };

    this.addRenderer = function(itemType, renderer) {
        renderers[itemType] = renderer;
    };

    this.getRenderers = function() {
        return renderers;
    };

    this.getContent = function() {
        return $content;
    };

    this.getHeaderConfiguration = function() {
        return {
            searchHeader : $searchField
        };
    };

    $(document).on("pagecreate", function() {
        $listView.filterable({input : $searchInput});
        $searchField.detach();
    });

    this.renderListview = function(resourceItems) {
        // Add received details about resources to the page

        $content.find(".helpText").remove();

        const layoutType = config.get("resourceView");
        self.renderResourceIcons(resourceItems, $listView, layoutType, this.onResourceItemClick);

        if (resourceItems.length < 1) {
            const messageText = $.t("common::" + self.getHeaderConfiguration().contentClass + ".view.empty", {defaultValue : ""});
            $listView.empty();
            $listView.prepend($("<div/>", {class : "helpText", text : messageText}));
        }
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "main";
    };

    /**
     * Get the weight for this view, used in the ordering of the tabs
     * @returns {int} The weighting of the view
     */
    this.getWeight = function() {
        return 100;
    };

    this.onResourceItemClick = function(e) {
        const $searchPanel = $("div.searchPanel");
        $searchPanel.find("input").val("");
        $searchPanel.find(".ui-btn.ui-input-clear").trigger("click");
        e.preventDefault();
        e.stopPropagation();
        const id = $(this).closest(".resourceItem,.resourceItemList").attr("data-resource-id");
        launcher(id);
    };

    this.resize = function(width, height) {
        $content.height(height);
        $content.outerWidth(width);

        // Reduce the remaining height by the size of the search panel if it is displayed inside the view
        const searchPanel = $content.find(".searchPanel");

        if (searchPanel.length > 0) {
            height -= searchPanel.outerHeight();
        }

        // Resize the listview to full width/height so that pull to refresh can be initiated anywhere on the view
        $listView.height(height);

        layoutIcons($listView);
    };

    const channel = postal.channel("AbstractResourcesView");
    channel.subscribe("update-resource", function(data) {
        const li = $listView.find("li[data-resource-id='" + data.resource.id + "']");

        if (li.length > 0) {
            const renderer = renderers[data.resource.type];

            if (renderer) {
                renderer.updateIcon(li, data.resource);
            }
        }
    });

    // Call refresh on pull-down
    $content.on("refresh", function() {
        postal.channel("Electron").publish("reload-resources");
    });
};

AbstractResourcesView.prototype = AbstractView;

module.exports = AbstractResourcesView;